import { useState } from "react";
import PetInformation from "../PetInformation";

const DopplerBP = () => {
  const [reading, setReading] = useState({ systolic: "", diastolic: "" });

  const handleChange = (field: "systolic" | "diastolic", value: string) => {
    setReading((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div className="overflow-x-auto p-4">
      <PetInformation />

      <div className="flex items-center gap-2 mt-3">
        <p className="text-xs font-semibold">Doppler BP reading:</p>
        <div className="flex items-center text-xs">
          <input
            type="text"
            value={reading.systolic}
            onChange={(e) => handleChange("systolic", e.target.value)}
            style={{ width: `${Math.max(reading.systolic.length, 3)}ch` }}
            className="border-b border-gray-500 text-center text-xs p-0 focus:outline-none"
          />
          <span>/</span>
          <input
            type="text"
            value={reading.diastolic}
            onChange={(e) => handleChange("diastolic", e.target.value)}
            style={{ width: `${Math.max(reading.diastolic.length, 3)}ch` }}
            className="border-b border-gray-500 text-center text-xs p-0 focus:outline-none"
          />
          <span className="ml-1">mmHg</span>
        </div>
      </div>

      <div className="mt-4">
        <p className="text-xs font-semibold">Reference Range:</p>
        <ul className="text-xs mt-1 ml-4 list-disc">
          <li>Dogs- 110/60 to 150/90 mmHg</li>
          <li>Cats- 120/70 to 160/100 mmHg</li>
        </ul>
      </div>

      <div className="flex items-center gap-2 mt-4">
        <p className="text-xs">Doctor's Name:</p>
        <input type="text" className="text-sm w-[400px] border p-1" />
      </div>

      <p className="mt-3 italic text-xs">This report is not valid for Vetero-Legal Purposes</p>
    </div>
  );
};

export default DopplerBP;
